module.exports = __webpack_public_path__ + "static/elsaM_screen00-b0b0a31b9379f3885b9e28c7d57e7143.jpg";